Object.defineProperty(exports,"__esModule",{value: true});
exports.default=window.GrimoireJS&&window.GrimoireJS.lib.math?window.GrimoireJS.lib.math.Matrix:undefined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/grimoirejs-math/ref/Matrix.js
// module id = 17
// module chunks = 0